import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import PlayerCell from "./PlayerCell";
import { createTableData, teamGameLeaders } from "./utils";
import type { GetGameLeadersQuery } from "@/graphql/gql/graphql";
import type { CellContext } from "@tanstack/react-table";

export type TableDataT = ReturnType<typeof teamGameLeaders>;

export const renderPlayerCell = (
  row: CellContext<TableDataT, TableDataT["passing_leader"]>
) => <PlayerCell {...row.getValue()} />;

const renderCompAtt = (
  row: CellContext<TableDataT, TableDataT["passing_throws"]>
) => (
  <div>{`${row.getValue().passing_completions}/${row.getValue().passing_attempts}`}</div>
);

const createColumns = () => {
  const columnHelper = createColumnHelper<TableDataT>();

  return [
    columnHelper.group({
      id: "passing",
      header: "Passing Yards",
      columns: [
        columnHelper.accessor("passing_leader", {
          header: "Name",
          cell: renderPlayerCell,
        }),
        columnHelper.accessor("passing_throws", {
          header: "COMP/ATT",
          cell: renderCompAtt,
        }),
        columnHelper.accessor("passing_yards", {
          header: "PASS YDS",
        }),
        columnHelper.accessor("passing_touchdowns", {
          header: "PASS TDS",
        }),
      ],
    }),
  ];
};

const usePassingTable = (data: GetGameLeadersQuery["event"]) => {
  const tableData = useMemo(() => createTableData(data), [data]);
  const columns = useMemo(createColumns, []);
  return {
    columns,
    data: tableData,
  };
};

export default usePassingTable;
